import { DeliveryStatus, DeliveryType } from "@types_def/models/delivery.types";
import {
  canUseAdminDeliveryActions,
  canViewDeliveryActions,
} from "@/components/Delivery/view-delivery-button-access";

type DeliveryStatusFlagsInput = {
  status: DeliveryStatus;
  type: DeliveryType;
  isAdmin: boolean;
  rank: number | undefined;
};

export function getDeliveryStatusFlags({ status, type, isAdmin, rank }: DeliveryStatusFlagsInput) {
  const isRequestedStatus = [
    DeliveryStatus.REQUESTED,
    DeliveryStatus.PENDING_CUSTOMER_CONFIRMATION,
    DeliveryStatus.SMS_SENT,
    DeliveryStatus.CONFIRMED_BY_CUSTOMER,
  ].includes(status);

  const isCompletedStatus = status === DeliveryStatus.COMPLETED;
  const isConfirmedStatus = status === DeliveryStatus.CONFIRMED;

  const isActiveAdminStatus = [
    DeliveryStatus.CONFIRMED,
    DeliveryStatus.WAITING_FOR_DRIVER,
    DeliveryStatus.ALERT,
    DeliveryStatus.SET,
  ].includes(status);

  const isInitialStatus = [
    DeliveryStatus.WAITING_FOR_DRIVER,
    DeliveryStatus.CONFIRMED,
    DeliveryStatus.REQUESTED,
  ].includes(status);

  const isCancelledStatus = [
    DeliveryStatus.CANCELLED_BY_ADMIN,
    DeliveryStatus.CANCELLED,
    DeliveryStatus.CANCELLED_BY_CUSTOMER,
    DeliveryStatus.CANCELLED_BY_MANDATORY,
  ].includes(status);

  const isOngoingStatus = [
    DeliveryStatus.PICKUP_CLIENT,
    DeliveryStatus.PICKUP_DRIVER,
    DeliveryStatus.ONGOING,
    DeliveryStatus.SWAP_DELIVERED,
    DeliveryStatus.DELIVERED,
    DeliveryStatus.SWAP_IN_TRANSIT,
    DeliveryStatus.SWAP_PICKUP_CLIENT,
    DeliveryStatus.SWAP_PICKUP_DRIVER,
  ].includes(status);

  const isDeliveryCodeVisible = [
    DeliveryStatus.SET,
    DeliveryStatus.PICKUP_CLIENT,
    DeliveryStatus.PICKUP_DRIVER,
    DeliveryStatus.ONGOING,
  ].includes(status);

  const isTwoWayDelivery = type === DeliveryType.TWO_WAY_DELIVERY;
  const canManageAdminActions = canUseAdminDeliveryActions(Boolean(isAdmin), rank);
  const canSeeActions = canViewDeliveryActions(Boolean(isAdmin), status);

  return {
    isRequestedStatus,
    isCompletedStatus,
    isConfirmedStatus,
    isActiveAdminStatus,
    isInitialStatus,
    isCancelledStatus,
    isOngoingStatus,
    isDeliveryCodeVisible,
    isTwoWayDelivery,
    canManageAdminActions,
    canSeeActions,
  };
}
